import { render } from "./ForumsThread.vue?vue&type=template&id=81a23f06"
import script from "./ForumsThread.vue?vue&type=script&lang=js"
export * from "./ForumsThread.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__